
































































































































































import {
  Component, Ref, Vue, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import CheckoutSection from '@/components/checkout/CheckoutSection.vue';
import FulfillmentOptions from '@/components/common/FulfillmentOptions.vue';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';
import RestaurantInfo from '@/components/common/RestaurantInfo.vue';
import { CartItemModel, CartModel } from '@/models/CartModel';
import Cart from '@/components/cart/Cart.vue';
import { SelectedMenuItem, SelectedMenuItemFull } from '@/types';
import MenuPopup from '@/components/popups/menu-popup/MenuPopup.vue';
import { createSelectedMenuItemFull, saveOrUpdateCartItem } from '@/utils/cart-utils';
import { MenuItemModel } from '@/models/MenuItemModel';
import Tip from '@/components/checkout/Tip.vue';
import ActionTypes from '@/constants/action-types';
import { CartItemRemoveRequestModel } from '@/models/CartRequestModel';
import SimplePopup from '@/components/popups/SimplePopup.vue';
import { validateEmail } from '@/utils/validation-utils';
import CheckoutButton from '@/components/checkout/CheckoutButton.vue';
import CartDetailedFooter from '@/components/cart/CartDetailedFooter.vue';
import SquarePaymentForm, { SquarePaymentFormCI } from '@/components/common/SquarePaymentForm.vue';
import { CheckoutRequestModel } from '@/models/CheckoutRequestModel';
import GoogleMap from '@/components/common/GoogleMap.vue';
import { CheckoutModel } from '@/models/CheckoutModel';
import { CurbsideModel } from '@/models/CurbsideModel';
import LoaderOverlay from '@/components/common/LoaderOverlay.vue';

@Component({
  components: {
    LoaderOverlay,
    GoogleMap,
    SquarePaymentForm,
    CartDetailedFooter,
    CheckoutButton,
    SimplePopup,
    Tip,
    MenuPopup,
    Cart,
    RestaurantInfo,
    FulfillmentOptions,
    CheckoutSection,
  },
  methods: {
    saveOrUpdateCartItem,
  },
})
export default class Checkout extends Vue {
  @Ref('anonymousNameRef') private readonly anonymousNameRef!: Vue;

  @Ref('anonymousEmailRef') private readonly anonymousEmailRef!: Vue;

  private selectedMenuItem: SelectedMenuItem | SelectedMenuItemFull | null = null;

  private cartItemToRemove: { item: CartItemModel; name: string } | null = null;

  private anonymousName = '';

  private anonymousEmail = '';

  private sendReceipt = false;

  private isPaymentFormValid = false;

  private showLoadingOverlay = false;

  private showSnackbar = false;

  private submitError: string | null = null;

  private paymentFormLoaded = false;

  mounted() {
    if (!(this.cart && this.merchant)) {
      this.$router.push({ name: 'MerchantDetails' });
    }
  }

  private get merchant(): MerchantDetailsModel {
    return this.$store.state.merchant.merchant;
  }

  private get cart(): CartModel | null {
    return this.$store.state.cart.cart;
  }

  private get isOrderValid(): boolean {
    return Boolean(this.cart?.cartItems?.length && this.anonymousName && this.isEmailValid && this.isPaymentFormValid);
  }

  private get isEmailValid(): boolean {
    return !this.anonymousEmail || validateEmail(this.anonymousEmail);
  }

  private get isNameValid(): boolean {
    return Boolean(this.anonymousName?.trim());
  }

  private get curbsideData(): CurbsideModel | null {
    return this.$store.state.curbsideData;
  }

  private get pickupDateTime(): moment.Moment {
    return this.$store.state.cart.pickupDateTime;
  }

  @Watch('anonymousEmail')
  private watchEmail() {
    if (this.isEmailValid) {
      this.sendReceipt = true;
    }
  }

  private onTipSelected(value: number | null) {
    this.$store.dispatch(`cart/${ActionTypes.AddCartTip}`, { type: 'dollar', tip: value });
  }

  private onEditCartItem(cartItem: CartItemModel, menuItem: MenuItemModel, merchantId: number) {
    this.selectedMenuItem = createSelectedMenuItemFull(cartItem, menuItem, merchantId);
  }

  private async onRemoveCartItem(item: CartItemModel): Promise<void> {
    // if it's the last item, just empty cart
    if (this.cart?.cartItems?.length === 1) {
      await this.$store.dispatch(`cart/${ActionTypes.EmptyCart}`);
      await this.$router.push({ name: 'MerchantDetails' });
    } else {
      const removeItem: CartItemRemoveRequestModel = { cartItemId: item.id };
      await this.$store.dispatch(`cart/${ActionTypes.RemoveCartItem}`, removeItem);
    }
  }

  private onChangeFormValid(valid: boolean): void {
    this.isPaymentFormValid = valid;
  }

  private checkFormValid(): void {
    (this.anonymousNameRef as any).validate(true); // eslint-disable-line
    (this.anonymousEmailRef as any).validate(true); // eslint-disable-line
  }

  private placeOrder(): void {
    this.showLoadingOverlay = true;
    this.checkFormValid();
    (this.$refs.square as SquarePaymentFormCI).requestCardNonce();
  }

  private async onCardNonceResponseReceived(nonce: string): Promise<void> {
    if (!(this.isNameValid && this.isEmailValid && Boolean(this.pickupDateTime))) {
      this.showLoadingOverlay = false;
      return;
    }

    const checkoutRequest: CheckoutRequestModel = {
      toGo: true,
      squareNonce: nonce,
      platform: 'apple',
      orderName: this.anonymousName,
      pickupDateTime: this.pickupDateTime.valueOf() / 1000,
    };

    if (this.sendReceipt && this.anonymousEmail) {
      checkoutRequest.email = this.anonymousEmail;
    }

    try {
      await this.$store.dispatch(`cart/${ActionTypes.Checkout}`, checkoutRequest);
      const checkoutModel: CheckoutModel = this.$store.state.cart.checkout;

      if (this.curbsideData) {
        const payload = {
          orderId: checkoutModel.orderId,
          curbsideData: this.curbsideData,
        };
        await this.$store.dispatch(`order/${ActionTypes.SaveCurbsideData}`, payload);
      }
      await this.$store.commit(`cart/${ActionTypes.EmptyCart}`);
      await this.$router.push({ name: 'Receipt', params: { orderId: `${checkoutModel.orderId}` } });
    } catch (e) {
      this.showLoadingOverlay = false;
      console.error(e);
      if (e.meta?.message) {
        this.showSnackbar = true;
        this.submitError = e.meta.message;
      }
    }
  }
}
